module.exports = __webpack_public_path__ + "static/media/pdf.f515caba.svg";